import React from 'react';
import { DialogActions, DialogContent, Dialog, Button } from '@mui/material';

export const Alert = ({ message, isOpen, onClose, isError = false }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <Dialog
            open={isOpen}
            onClose={() => onClose()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ zIndex: 9999 }}
        >
            {isError ? <h1 className='p-2 text-2xl font-bold text-red-500'>Error</h1> : <h1 className='p-2 text-2xl font-bold'>Alert</h1>}


            {/* Divider */}
            <hr style={{ width: '100%', color: 'red' }} />
            <DialogContent style={{ minWidth: "300px", maxWidth:"600px" }}>
                {message}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose()} color={isError ? 'error' : 'info'} autoFocus>
                    CLOSE
                </Button>
            </DialogActions>
        </Dialog>
    );
};
